import angular from 'angular';
import referralNoteItem from './referralNoteItem';
import './style.scss';

export default angular
  .module('scenes.referral.components.referralNoteItem', [])
  .component('referralNoteItem', referralNoteItem).name;
